import React from 'react'
import useCommonStyles from './SucccessStep.style'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import SuccessAnimation from '@components/SuccessAnimation'
import Page from '@components/Page'
import Header from '@components/Header'
import Footer from '@components/Footer'
import { Button } from '@components/Button/Button'
import { useCloseAvailyContext } from '@context/CloseAvailyContext'

const SuccessStep = () => {
  const { t } = useTranslation()
  const classes = useCommonStyles()
  const closeAvaily = useCloseAvailyContext()

  return (
    <Page
      header={<Header desktopHeadingText="" mobileHeadingText="" hideStatusBar />}
      body={
        <div className={classes.wrapper}>
          <div className={classes.animationContainer}>
            <SuccessAnimation className={classes.animation} />
          </div>
          <Typography className={classes.text}>{t('survey_success_text')}</Typography>
        </div>
      }
      footer={
        <Footer
          button={
            <Button onClick={() => closeAvaily?.()} type="submit" fullSize text={t('gap_filler_survey_success_cta')} />
          }
        />
      }
    />
  )
}

export default SuccessStep
